import React, { Component } from 'react';

import DmarcSelector from '../../components/domain-portfolio/dmarc-selector';
import PropTypes from 'prop-types';
import { changeDmarcPassType } from '../../../common/actions/domain-portfolio-dmarc-selector-action-creators';
import { connect } from 'react-redux';
import { selectedDmarcPassTypeSelector } from '../../selectors/reports-selectors';

export class DomainPortfolioDmarcSelectorContainer extends Component{
    render(){
        const { selectedDmarcPassType, changeDmarcPassType } = this.props;
        return (
            <DmarcSelector
                automationId="dmarc-pass-type-selector"
                handleDmarcPassTypeChange={changeDmarcPassType}
                selectedDmarcPassType={selectedDmarcPassType}
            />
        );
    }
};

DomainPortfolioDmarcSelectorContainer.propTypes = {
    changeDmarcPassType: PropTypes.func.isRequired,
    selectedDmarcPassType: PropTypes.string.isRequired
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        selectedDmarcPassType: selectedDmarcPassTypeSelector( state )
    };
};

export default connect( mapStateToProps, { changeDmarcPassType } )( DomainPortfolioDmarcSelectorContainer );
